import { graphql, useFragment } from "react-relay";
import { Box } from "arkh";
import {
  TodoListItemProductsMultipleProducts,
  TodoListItemProductsSingleProduct,
} from "widgets/src/TodoListItem/TodoListItemFooter/TodoListItemProducts";

export function WorkspaceTodoListItemProducts(props: { products: any }) {
  const products = useFragment(
    graphql`
      fragment WorkspaceTodoListItemProducts_WorkspaceProduct on WorkspaceProduct
      @relay(plural: true) {
        name
      }
    `,
    props.products
  );

  if (products.length === 0) {
    return null;
  }

  return (
    <Box style={{ flexDirection: "row", alignItems: "center" }}>
      {products.length === 1 ? (
        <TodoListItemProductsSingleProduct
          productTitle={products[0]?.name ?? ""}
        />
      ) : (
        <TodoListItemProductsMultipleProducts
          numberOfProducts={products.length}
        />
      )}
    </Box>
  );
}
